import { UseFormReturn } from "react-hook-form";
import useActiveRegions from "@/features/regions/hooks/use-active-regions";
import { codeToFlag } from "@/features/regions/utils/code-to-flag";
import { FormPreview } from "@/pages/forms/types/form";
import { PROVIDER_LABEL } from "@/features/forms/constants";
import { FormWizardData } from "./wizard-form";

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex justify-between gap-4 py-2 border-b border-gray-100 last:border-0">
      <span className="text-sm text-gray-500">{label}</span>
      <span className="text-sm text-gray-900 text-right break-all">
        {value || "—"}
      </span>
    </div>
  );
}

export default function StepReview({
  form,
  preview,
}: {
  form: UseFormReturn<FormWizardData>;
  preview: FormPreview | null;
}) {
  const v = form.getValues();
  const { data: regions } = useActiveRegions();
  const region = regions?.find((r) => r.id === v.region_id);
  const name =
    preview?.title ?? `(pulled from ${PROVIDER_LABEL[v.provider]} on save)`;

  return (
    <div className="rounded-lg border border-gray-200 divide-y divide-gray-100">
      <div className="px-4 py-3 bg-gray-50">
        <p className="text-base font-semibold text-gray-900">{name}</p>
        <p className="text-xs text-gray-500">
          {region ? `${codeToFlag(region.code)} ${region.display_name}` : "—"} ·{" "}
          {PROVIDER_LABEL[v.provider]} · {v.status}
        </p>
      </div>
      <div className="px-4 py-2">
        <Row label="Source ID" value={v.source_id} />
        <Row label="Department" value={v.department} />
        {preview && <Row label="Questions" value={preview.questionsCount} />}
        <Row label="Bundles" value={v.bundle_ids?.length || 0} />
        <Row label="Doc link" value={v.doc_link ? "✓ set" : "—"} />
      </div>
    </div>
  );
}
